import { render, staticRenderFns } from "./LocalityWidget.vue?vue&type=template&id=0c1b1be4&"
import script from "./LocalityWidget.vue?vue&type=script&lang=ts&"
export * from "./LocalityWidget.vue?vue&type=script&lang=ts&"
import style0 from "./LocalityWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports